import { StringUtility } from "@common/utils"

export interface IMacroKeywords {
    "{{hospitalname}}": string
    "{{hospitalemail}}": string
    "{{hospitalphone}}": string
    "{{hospitalcity}}": string
    "{{hospitaladdress}}": string
    "{{hospitalurl}}": string
    "{{clientfirstname}}": string
    "{{clientlastname}}": string
    "{{clientfullname}}": string
    "{{petname}}": string
    "{{vetname}}": string
    "{{todaysdate}}": string
}

export class MacroKeywords implements IMacroKeywords {
    "{{hospitalname}}": string
    "{{hospitalemail}}": string
    "{{hospitalphone}}": string
    "{{hospitalcity}}": string
    "{{hospitaladdress}}": string
    "{{hospitalurl}}": string
    "{{clientfirstname}}": string
    "{{clientlastname}}": string
    "{{clientfullname}}": string
    "{{petname}}": string
    "{{vetname}}": string
    "{{todaysdate}}": string

    constructor(params: Partial<IMacroKeywords>) {
        //updated  so empty strings aren't counted as values.
        this["{{hospitalname}}"] = _.defaultTo(StringUtility.SanitizeString(params["{{hospitalname}}"]), "{{hospitalname}}");
        this["{{hospitalemail}}"] = _.defaultTo(StringUtility.SanitizeString(params["{{hospitalemail}}"]), "{{hospitalemail}}");
        this["{{hospitalphone}}"] = _.defaultTo(StringUtility.SanitizeString(params["{{hospitalphone}}"]), "{{hospitalphone}}");
        this["{{hospitalcity}}"] = _.defaultTo(StringUtility.SanitizeString(params["{{hospitalcity}}"]), "{{hospitalcity}}");
        this["{{hospitaladdress}}"] = _.defaultTo(StringUtility.SanitizeString(params["{{hospitaladdress}}"]), "{{hospitaladdress}}");
        this["{{hospitalurl}}"] = _.defaultTo(StringUtility.SanitizeString(params["{{hospitalurl}}"]), "{{hospitalurl}}");
        this["{{clientfirstname}}"] = _.defaultTo(StringUtility.SanitizeString(params["{{clientfirstname}}"]), "{{clientfirstname}}");
        this["{{clientlastname}}"] = _.defaultTo(StringUtility.SanitizeString(params["{{clientlastname}}"]), "{{clientlastname}}");
        this["{{clientfullname}}"] = _.defaultTo(StringUtility.SanitizeString(params["{{clientfullname}}"]), "{{clientfullname}}");
        this["{{petname}}"] = _.defaultTo(StringUtility.SanitizeString(params["{{petname}}"]), "{{petname}}");
        this["{{vetname}}"] = _.defaultTo(StringUtility.SanitizeString(params["{{vetname}}"]), "{{vetname}}");
        this["{{todaysdate}}"] = _.defaultTo(StringUtility.SanitizeString(params["{{todaysdate}}"]), "{{todaysdate}}");
    }

    /**
     * Replaces all keyword placeholders in text passed in with values from keywords param in one shot.
     * @param text The text with placeholders in it that need replaced
     * @param keywords  The keyword values to replace them with.
     * @returns Transformed where any variables have been replaced by keywords that have values, if no value the placeholder will remain.
     */
    static processTextForMacros(text: string, keywords: MacroKeywords) {
        if (text === undefined) return;
        const reg = new RegExp(Object.keys(keywords).join("|"), "g");
        return text.replace(reg, (matched: string) => keywords[matched as keyof MacroKeywords]);
    }
}
